import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { LzPopupComponent } from '../components/lz-popup/lz-popup.component';

import { CustomRequestService } from '../../../services/custom-request/custom-request.service';
import { LzProductConfig } from '../../../services/product-config/poduct-config';
import { LzCookieService } from '../../../services/lz-cookie/lz-cookie';

@Injectable()
export class LzPopupService {

  private lzPopupDialogRef: MatDialogRef <LzPopupComponent> ;
  private lzPopupDialogOptions: any = {
    autoFocus: false,
    panelClass: 'lz-popup-overlay',
    disableClose: 'true'
  };

  constructor(private request: CustomRequestService, private config:LzProductConfig, public dialog: MatDialog, private cookie: LzCookieService) {

  }

   private showPopup = (popupData: any) => {
      this.lzPopupDialogOptions.data = popupData;
      this.lzPopupDialogRef = this.dialog.open(LzPopupComponent, this.lzPopupDialogOptions);
   }

   public checkForPopup = () => {
      if(this.config.getProductSettings()['product_name'] && this.config.getProductSettings()['product_name'].length > 0) {
         this.request.getRequest(this.config.getApiLink() + '/lz-platforma/cms/v1.0/popup/' + this.config.getProductSettings()['order_code']).subscribe((msg) => {
           if(msg) {
              if(this.cookie.getCookie('popupNeverShow' + msg.id)) {
                return;
              }
              if(msg.frequency) {
                try {
                  let showDate = Number(this.cookie.getCookie('popupShowDate' + msg.id));
                  if(!showDate) {
                    if(msg.after) {
                      try {
                        setTimeout(() => {
                          this.showPopup(msg);
                        }, msg.after * 1000);
                      } catch(e) {
                        this.showPopup(msg);
                      }
                    } else {
                      this.showPopup(msg);
                    }
                  } else {
                    let currentDate = new Date();
                    let popupDate = new Date(showDate);
                    if (currentDate.getDate() === popupDate.getDate() && currentDate.getMonth() === popupDate.getMonth() && currentDate.getFullYear() === popupDate.getFullYear()) {
                      if(msg.after) {
                        try {
                          setTimeout(() => {
                            this.showPopup(msg);
                          }, msg.after * 1000);
                        } catch(e) {
                          this.showPopup(msg);
                        }
                      } else {
                        this.showPopup(msg);
                      }
                    } else {
                      return;
                    }
                  }
                } catch(e) {
                  return;
                }
              }
           }
         });
      }
   }
}
